import React, { useEffect } from 'react';
import './SelectProducts.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Cover from '../Cover/Cover';
import Product from '../Product/Product';
import { filterFloorplans, updateProductFilterValue } from '../../redux/actions/floorplanActions';

function SelectProducts() {
    var dispatch = useDispatch();
    var content = useSelector(state => state.content.pages.floorplans);
    var products = useSelector(state => state.floorplan.products);
    var history = useHistory();
    const isTouchScreen = useSelector((state) => state.utilities.isTouchScreen);
    var floorplans = useSelector(state => state.floorplan.floorplans);

    function clickNavigate(key, value) {
        //we need to update teh filter value and also filter the floorplans before we move to that page
        dispatch(updateProductFilterValue(key, value));
        dispatch(filterFloorplans());
        history.push('/floorplans/list');
    }

    function productHasActiveLots(product) {
        for(var i = 0; i < floorplans.length;i++) {
            if(floorplans[i].type[0].name == product.name) return "";
        }

        return " hide";
    }

    if(typeof content !== 'undefined') {
        return (
            <div className={`SelectProducts${isTouchScreen ? " touchscreen" : ""}`}>
                <Cover fadeImmediately />
                <h1 className='heading'>
                    {content.floorplan_product_type_heading}
                </h1>
                <div className='product-card-container'>
                    {products.map((product, key) => 
                        <button
                            className={`product-card${productHasActiveLots(product)}`}
                            onClick={() => clickNavigate(key, product.term_id)}
                        >
                            <div className='product-image-wrapper'>
                                <img
                                    className='product-image'
                                    src={content.floorplan_product_type_data[key].product_image.url}
                                />
                            </div>
                            <h2
                                className='product-heading'
                            >
                                {product.name}
                                {content.floorplan_product_type_data[key].product_after_type_text}
                            </h2>
                            {false && (
                                <p
                                    className='product-copy'
                                >
                                    {content.floorplan_product_type_data[key].product_description}
                                </p>
                            )}
                            <div
                                className='product-display-container'
                            >
                                <div
                                    className='stats-container'
                                >
                                    {content.floorplan_product_type_data[key].product_stats.map((stat, sKey) => {
                                        //console.log(stat);

                                        return (
                                        <div className='stat'>
                                            <img 
                                                src={stat.icon}
                                                className='icon'
                                            />
                                            <span className='content'>
                                                {stat.content}
                                            </span>
                                        </div>
                                        )
                                    })}
                                </div>
                                <img
                                    src={content.floorplan_product_type_data[key].product_icon.url}
                                    className='display-icon'
                                />
                            </div>
                        </button>
                    )}
                </div>
            </div>
        )
    }
    else {
        return (
            <div></div>
        )
    }
}

export default SelectProducts;
